/*
 * Copyright (c) 2016-2019 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component } from '@angular/core';

@Component({
  selector: 'clr-dg-column-toggle-title',
  template: `<ng-content></ng-content>`,
})
/** @deprecated since 2.0, remove in 3.0 */
export class ClrDatagridColumnToggleTitle {}
